import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import images from '../constants/images';
import { ShieldCheckIcon, SunIcon, PhoneIcon } from '@heroicons/react/24/outline';

const AboutUs = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: `url(${images.image2})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backdropFilter: 'blur(5px)',
        }}
        className="bg-fixed"
      >
        <Navbar />
        <section className="py-20 px-4 text-white">
          <div className="max-w-6xl mx-auto text-center">
            <h1 className="text-4xl font-bold mb-6 animate-fade-in-up">
              About Zab Tours and Travels Services
            </h1>
            <p className="text-xl text-[#003b6f] mb-8">
              Revolutionizing urban mobility since 2015
            </p>
          </div>
        </section>
      </div>

      <main className="flex-grow">
        {/* Our Story Section */}
        <section className="py-16 px-4 bg-white">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="animate-fade-in-left">
                <img
                  src={images.carimage}
                  alt="Our journey"
                  className="rounded-xl shadow-lg object-cover w-full h-auto"
                />
              </div>
              <div className="animate-fade-in-right">
                <h2 className="text-3xl font-bold mb-6">Our Story</h2>
                <p className="text-gray-600 mb-4">
                  Founded in 2015, Zab Tours and Travels started with a simple vision—to revolutionize urban transportation
                  by offering safe, reliable, and affordable rides. What began as a small fleet of just 10 vehicles
                  has now grown into a trusted travel partner with an extensive presence across 15 cities.
                </p>
                <p className="text-gray-600 mb-4">
                  Over the years, we have continuously evolved, embracing technology and innovation to enhance
                  our customer experience. Whether it’s daily commutes, corporate travel, or luxury rides, we have
                  tailored our services to meet diverse customer needs. With a customer-first approach, we have proudly
                  served over 1 million passengers annually, making every journey smooth and hassle-free.
                </p>
                <p className="text-gray-600 mb-4">
                  As we continue to expand, our mission remains unchanged—to redefine travel with reliability,
                  affordability, and unparalleled service. Whether you're traveling for work, leisure, or special occasions,
                  we are committed to making your journey memorable. Thank you for being a part of our story—we look
                  forward to serving you for years to come.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Our Values Section */}
        <section className="py-16 px-4 bg-gray-50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12">Our Values</h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  title: 'Safety First',
                  icon: <ShieldCheckIcon className="text-blue-500 w-8 h-8" />,
                  content: '24/7 ride monitoring and verified drivers',
                },
                {
                  title: 'Eco-Friendly',
                  icon: <SunIcon className="text-green-600 w-8 h-8" />,
                  content: '30% electric fleet with carbon offset programs',
                },
                {
                  title: '24/7 Support',
                  icon: <PhoneIcon className="text-yellow-500 w-8 h-8" />,
                  content: 'Round-the-clock customer service team',
                },
              ].map((value, index) => (
                <div
                  key={index}
                  className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 animate-fade-in-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="text-4xl mb-4">{value.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{value.title}</h3>
                  <p className="text-gray-600">{value.content}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Coverage Section - Our Services in All States */}
        <section className="py-16 px-4 bg-white">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8">
            <div className="w-full md:w-1/2 animate-fade-in-right">
              <h2 className="text-3xl font-bold mb-6">Across the Nation, Every Journey Unites Us</h2>
              <p className="text-gray-600 mb-4">
                At Zab Tours and Travels, we believe that every road whispers a promise and every destination tells its own tale.
                From the bustling cities to the serene countryside, our network spans every state, ensuring you experience safe,
                reliable, and affordable transportation wherever you may roam.
              </p>
              <p className="text-gray-600 mb-4">
                With a devoted team and cutting-edge technology, we orchestrate timely pickups and seamless travel, transforming
                urban mobility into a poetic voyage that connects hearts and horizons. Let us guide your next adventure across this beautiful nation.
              </p>
              <p className="text-gray-800 mb-4 font-semibold">
                While the image may spotlight a few select cities, it is only a glimpse of our expansive network.
                At Zab Tours and Travels, our services stretch far and wide—reaching every state, every town, and every corner of the nation.
              </p>
            </div>
            <div className="w-full md:w-1/2 animate-fade-in-left">
              <img
                src={images.allstates || images.defaultMap}
                alt="Nationwide Coverage"
                className="rounded-xl shadow-lg object-cover w-full h-auto"
              />
            </div>

          </div>
        </section>

        {/* Team Section */}
        {/* <section className="py-16 px-4 bg-white">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12">Leadership Team</h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  name: 'Gulam Nabi Shaikh',
                  role: 'CEO & Founder',
                  phone: '8329067113',
                },
                {
                  name: 'Gulam Mustafa Shaikh',
                  role: 'CTO',
                  phone: '7666313579',
                },
                {
                  name: 'Gulam Nabi Shaikh',
                  role: 'COO',
                  phone: '8806003303',
                },
              ].map((member, index) => (
                <div
                  key={index}
                  className="group relative flex flex-col justify-center items-center h-64 p-6 rounded-xl shadow-lg bg-gradient-to-br from-gray-800 to-gray-900 text-white hover:scale-105 transition-transform duration-300 animate-fade-in-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-white/5 to-transparent rounded-xl pointer-events-none" />
                  <div className="absolute inset-0 overflow-hidden rounded-xl pointer-events-none">
                    <div className="absolute -left-[50%] -top-[50%] w-[200%] h-[200%] bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform rotate-45 group-hover:translate-x-[50%] group-hover:translate-y-[50%]" />
                  </div>
                  <h3 className="text-2xl font-bold">{member.name}</h3>
                  <p className="text-gray-300">{member.role}</p>
                  <p className="text-gray-400">{member.phone}</p>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* CTA Section */}
        <section className="bg-[#003b6f] text-white py-16 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Ready to Ride With Us?</h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link
                to="/contactus"
                className="bg-yellow-400 text-gray-900 px-8 py-3 rounded-lg hover:bg-yellow-500 transform transition-all duration-300 hover:scale-105"
              >
                Contact Us
              </Link>
              <Link
                to="/services"
                className="bg-white text-[#1a365d] px-8 py-3 rounded-lg hover:bg-gray-100 transform transition-all duration-300 hover:scale-105"
              >
                Our Services
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutUs;
